const theme = {
    isBuiltIn: true,
    id: "space",
    name: "Space",
    showLogo: true,
    logoScale: 1,
    logoPosition: "left",
    logoOffset: 0,
    showMessage: true,
    showPageNum: true,
    logo: null,
    logo_dark: null,
    showFooterByDefault: null,
    palette_name: "space",
    defaultSlideColor: "theme",
    defaultBackgroundColor: "background_light",
    styleFonts: 1,
    styleFontWeight: "heavy",
    styleElementStyle: "filled",
    styleEffect: "none",
    styleDesign: 1,
    styleDecoration: "bar_top_center",
    styleHeaderAlignment: "left",
    styleShape: "circle",
    styleColor: "slide",
    styleBackground: "none",
    styleTitleFont: "sourcesanspro",
    styleBodyFont: "sourcesanspro",
    styleWeight: "light",
    styleTitleSlide: "bar_left",
    fontScale: 1,
    iconStyle: "classic",
    cjkFont: "jp",
    fontHeaderFontId: "poppins",
    fontHeaderWeight: 400,
    fontHeaderLetterSpacing: 0.01,
    fontHeaderLineHeight: 1.5,
    fontHeaderScaling: 95,
    fontHeaderTextTransform: "auto",
    fontTitleFontId: "spacemono",
    fontTitleWeight: 400,
    fontTitleLetterSpacing: 0,
    fontTitleLineHeight: 1.8,
    fontTitleScaling: 80,
    fontTitleTextTransform: "auto",
    fontBodyFontId: "spacemono",
    fontBodyWeight: 400,
    fontBodyLetterSpacing: 0,
    fontBodyLineHeight: 2,
    fontBodyScaling: 80,
    fontBodyTextTransform: "auto",
};

module.exports = theme;
